/**
 * Whether an error is an HTTP 403. Pure (not a hook) so the react-query retry policy can call it too.
 * Reads both the legacy axios `response.status` and the newer flat `status` shape.
 */
export const isForbiddenError = (error: unknown): boolean => {
  const candidate = error as { response?: { status?: number }; status?: number } | null | undefined;
  return (candidate?.response?.status ?? candidate?.status) === 403;
};
